import React from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as adBannersActions from '../actions/adBannersActions';
import PropTypes from "prop-types";
import InlineInputSubscription from '../subscriptions/inlineInput';
import InjectInsideHtmlComponent from "../base/injectInsideHtmlComponent";
import {ParseShortcodeAttrsForInlineInput} from "../subscriptions/shortcodeUtils";
import {parseCookies, setCookie} from "../base/cookieHelper";
import AdBannersApi from "../api/adBanners";
import AdWrapping from "./adWrapping";

class AdRender extends React.Component{

    state= {
        bannerScriptLoaded: false,
        id: Math.random().toString(36).substring(7)
    };
    bannerRef = React.createRef();

    componentDidMount() {
        this.processBannerScript();
        this.detectElementVisibility();
    }

    componentDidUpdate() {
        this.processBannerScript();
        this.detectElementVisibility();
    }

    shouldComponentUpdate(nextProps){
        return (!this.props.banner && !!nextProps.banner);
    }

    detectElementVisibility = () => {

        if(!this.props.banner){
            return;
        }
        const observer = new IntersectionObserver(([entry]) => {
            if(entry.isIntersecting === true){
                this.trackImpression(this.props.banner.id);
                observer.disconnect();
            }

        });
        observer.observe(this.bannerRef.current);
    };

    trackImpression = (bannerId) => {
      let showedBanners = parseCookies('hr_ads', []);
      if (showedBanners.indexOf(bannerId) < 0){
          showedBanners.push(bannerId);
          setCookie('hr_ads', showedBanners);
          AdBannersApi.trackImpression(bannerId);
      }
    };

    trackClick = (e) => {
        let clickedBanners = parseCookies('hr_ads_c', []);
        if (!!this.props.banner.id && clickedBanners.indexOf(this.props.banner.id) < 0 && e.target.matches('a, a *')) {
            clickedBanners.push(this.props.banner.id);
            setCookie('hr_ads_c', clickedBanners);
            AdBannersApi.trackClick(this.props.banner.id)
        }
    };

    processBannerScript = () => {
        if (this.props.banner && !this.state.bannerScriptLoaded){
            let element = document.getElementById(this.state.id);
            if (!!element){
                Array.from(element.getElementsByTagName('SCRIPT')).forEach(function(element) {
                    const script = element.text;
                    window.eval(script);
                });
            }
            this.setState({bannerScriptLoaded: true});
        }
    };

    renderAd(){
        if(!this.props.banner){
            return null;
        }

        const htmlCode = this.props.banner.code;

        if (this.props.banner.newsletter_form_attrs) {
            const parsedAttrs = ParseShortcodeAttrsForInlineInput(htmlCode, {...this.props.banner.newsletter_form_attrs});
            return <InjectInsideHtmlComponent regex={/\[InlineForm.[^\]]*\]/i} passedComponent={InlineInputSubscription}
                                              html={this.props.banner.code} passedAttrs={parsedAttrs} />
        }

        return <div id={this.state.id} ref={bannerElement => (this.bannerElement = bannerElement)}
                    className={this.props.className}
                    dangerouslySetInnerHTML={{__html: htmlCode}} />;
    }

    render() {
        if(!this.props.banner){
            return null;
        }

        return (
            <AdWrapping bannerType={this.props.banner.banner_type}>
                <aside ref={this.bannerRef} onClick={this.trackClick}>
                    {this.renderAd()}
                </aside>
            </AdWrapping>)
    }
}
AdRender.propTypes = {
    adBanners: PropTypes.object

};

function mapStateToProps(state, ownProps) {
    // let banner = null;

    let filteredCollection = state.adBanners.collection;

    if (ownProps.code) {
        filteredCollection = state.adBanners.collection.filter((ad) => ad.slot_code === ownProps.code);
        // banner = state.adBanners.collection.filter((ad) => ad.slot_code === ownProps.code)[0];
    } else if (ownProps.banner_type) {
        filteredCollection = state.adBanners.collection.filter((ad) => ad.banner_type === ownProps.banner_type);
        // let randElement = Math.floor(Math.random() * state.adBanners.collection.length);
        // banner = state.adBanners.collection[randElement];
    }

    let randElement = Math.floor(Math.random() * filteredCollection.length);
    // banner = filteredCollection[randElement];

    return {
        banner: filteredCollection[randElement]
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, adBannersActions), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(AdRender);
